var map = {
	"./arg.svg": 940,
	"./aus.svg": 941,
	"./bel.svg": 942,
	"./bra.svg": 943,
	"./can.svg": 944,
	"./cmr.svg": 945,
	"./crc.svg": 946,
	"./cro.svg": 947,
	"./den.svg": 948,
	"./ecu.svg": 949,
	"./eng.svg": 950,
	"./esp.svg": 951,
	"./fra.svg": 952,
	"./ger.svg": 953,
	"./gha.svg": 954,
	"./irn.svg": 955,
	"./jpn.svg": 956,
	"./kor.svg": 957,
	"./ksa.svg": 958,
	"./mar.svg": 959,
	"./mex.svg": 960,
	"./ned.svg": 961,
	"./pol.svg": 962,
	"./por.svg": 963,
	"./qat.svg": 964,
	"./sen.svg": 965,
	"./srb.svg": 966,
	"./sui.svg": 967,
	"./tun.svg": 968,
	"./uru.svg": 969,
	"./usa.svg": 970,
	"./wal.svg": 971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2508;